//生产地址为https://mobile.1sign.cn
//var serverUrl = "https://mobile.1sign.cn";
//本机开发地址
// var serverUrl = "http://192.168.50.121:8082/dataAPI/";
//预生产地址
//var serverUrl = "http://dataapi.yushengchan.1sign.cn"
//测试环境地址
//var serverUrl = "http://101.201.254.163:8199/dataAPI/"

//ceshi
// var port = '8180';
// var projectName = "/dataapi";
// var url = serverUrl + ":" + port + projectName;
let url
if (process.env.NODE_ENV == 'development') {
    url = '/api';
} else {
    url = '/api';
}
//var url = process.env.BASE_API;
//首页
global.webmobileurl = "https://www.1sign.cn";
var _all_serverUl = {
    _isme: url + "/me", //获取登录态
    _logout: url + '/logout',
    // 新版实名认证
    _sendMsg: url + '/logged/front/approval/sendMsg',
    _checkBank: url + '/logged/front/approval/checkBank',
    _setSignCode: url + '/logged/front/approval/setSignCode',
    //对接华信
    _judgeContractIsLaw: url + '/logged/contract/judgeContractIsLaw',
    _comboSearch: url + '/logged/front/combo/search',

    _policyDefault: url + '/logged/cert/policy/default',
    
    _verifyPhone: url + '/logged/verifyPhone',
    _loginUrl: url + "/login/login.do", // 登录
    _bindMobile: url + "/logged/front/acount/bindMobile.do", //绑定手机号
    _findpassUrl: url + "/register/next.do", // 忘记密码
    _checkFindPass: url + "/register/checkFindPass.do", // 忘记密码发送短信验证码
    _getyzmUrl: url + "/register/getyzm.do", // 获取验证码(忘记密码) 15:银行认证手机验证码
    _getValidateCode: url + "/logged/front/acount/sendValidateCode", //新版验证码

    _setpassUrl: url + "/register/setPass.do", // 设置密码
    _registerNextUrl: url + "/register/registernext.do", // 注册
    _imgCodeUrl: url + "/register/frontcode/code.do", // 获取图形验证码
    _regCodeUrl: url + "/register/register.do", // 获取注册验证码
    _finMySign: url + "",
    _updateSignStatus: url + "/logged/front/signature/updateSignStatus", //修改签名默认状态
    _deleteSignFile: url + "/logged/front/signature/deleteSignFile", //删除签名
    _findMySign: url + "/logged/front/signature/init", //获取我的签名
    _uploadContract: url + "/logged/contract/upload.do", //上传文件签名
    _dtrqs: url + "/logged/contract/dtrqs/query.do", //待他人签署
    _dwqs: url + "/logged/contract/dwqs/query.do", //待我签署
    _bankApproval: url + "/logged/front/approval/checkBank", //银行卡号认证
    // _bankApprovalPersonal: url + "/logged/front/approval/personalCheckBank",
    _bankApprovalPersonal: url + "/logged/front/approval/bankApproval",
    _cgx: url + "/logged/contract/cgx/query.do", //草稿箱签署
    _ywc: url + "/logged/contract/ywc/query.do", //已完成签署
    _qt: url + "/logged/contract/other/query.do", //其他签署
    _total: url + "/logged/contract/all/query.do", //全部签署
    _showcontract: url + "/logged/contract/sign/show.do",
    _judgezhang: url + "/logged/contract/judgezhang.do",
    _judge1: url + "/logged/contract/sign/judge1.do",
    _judge2: url + "/logged/contract/sign/judge2.do",
    _judge3: url + "/logged/contract/sign/judge3.do",
    _judge4: url + "/logged/contract/sign/judge4.do",
    _goSign: url + "/logged/contract/sign/goSign.do",
    _initiate: url + "/logged/contract/sign/initiate.do",
    _signing: url + "/logged/contract/sign/save.do",
    _checkSignPass: url + "/logged/contract/sign/checkCode.do",
    _refuse: url + "/logged/contract/sign/refuseSign.do",
    _detailcont: url + "/logged/contract/querySignFlows.do",
    _addSigner: url + "/logged/contract/sign/addSigner.do",
    _getMobile: url + "/logged/contract/getMobile.do",
    _isAddSignered: url + "/logged/contract/isAddSignered.do",
    _isSigned: url + "/logged/contract/isSigned.do",
    _isRefuseed: url + "/logged/contract/isRefuseed.do",
    _headSignFromSign: url + "/logged/front/signature/through/headSignFromSign",
    _mainIndex: url + "/logged/index", // 个人中心数据
    _headSign: url + "/logged/front/signature/through/headSign", //上传手写签名
    _checkIdCard: url + "/logged/front/zm/approval/checkIdCard", //验证手机号
    _queryMyContactsync: url + "/logged/front/contacts/querysync", //获取我的联系人
    _addContacts: url + "/logged/front/contacts/addContacts", //新建我的联系人
    _deleteContacts: url + "/logged/front/contacts/deleteContacts", //删除我的联系人
    _editContacts: url + "/logged/front/contacts/editContacts", //修改我的联系人
    _editUserPassword: url + "/logged/front/acount/nextPwd", // 修改密码
    _nextPwdCode: url + "/logged/front/acount/nextPwdCode", //修改签约密码
    _nextEmail: url + "/logged/front/acount/nextEmail", //绑定邮箱
    _nextValidateOldEmail: url + "/logged/front/acount/next", //验证原邮件验证码是否正确
    _accountInfo: url + "/logged/front/acount/acount", //MY页面，账户信息
    _myCombosync: url + "/logged/front/combo/combosync", //我的套餐
    _myComborecord: url + "/logged/front/combo/record", //我的套餐购买记录
    _comboListsync: url + "/logged/front/combo/querysync", //套餐列表显示
    _photoadd: url + "/logged/front/photo/add", //上传头像
    _alipay: url + "/logged/alipay/pay", //购买套餐
    _payOldOrder: url + "/logged/alipay/payOldOrder", //完成购买套餐
    _getCombo: url + "/logged/front/combo/getCombo", //获取套餐信息
    _wxpay: url + "/logged/pay/weixinpay/createOrder", //获取套餐信息
    _payOrderSync: url + "/logged/pay/payOrderSync", //同步用戶付款状态
    _getOrderByOrderNo: url + "/logged/front/order/getOrderByOrderNo", //获取订单信息
    _wxpayOldOrder: url + "/logged/pay/weixinpay/wxpayOldOrder", //同步用戶付款状态
    _fcert: url + "/logged/front/approval/approvalsync", // 查看证书
    _zhimaApproval: url + "/logged/front/zm/approval/getUrl", //芝麻认证
    _checkProtocolStatus: url + "/logged/checkProtocolStatus", // 数字协议证书
    _signProtocol: url + "/logged/signProtocol", // 签署数字证书协议
   
};

var _whiteUrlWithoutTickId = {
    _rooturl: url,
    _logoutUrl: url + "/login/logout.do",
    _imgView: url + "/front/photo/download/", // 头像预览
    _mailyzm: url + "/register/mailyzm", //邮箱验证码
    _approvalSync: url + "/zm/approval/through/zmNotify", //芝麻认证
    _serverUrl: url,
}


const domain = url;

function outMessage(key) {
    if (_whiteUrlWithoutTickId.hasOwnProperty(key)) {
        return _whiteUrlWithoutTickId[key];
    }
    // var url = _all_serverUl[key] + "?ticketId=" + localStorage.getItem('ticketId');
    var url = _all_serverUl[key];
    return url;
}

export { outMessage as default };


// WEBPACK FOOTER //
// ./src/js/domain.js